import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fullscreenCardAnimation, cardFeedAnimation, modelFeedAnimation, homeOverscrollAnimation, navbarmodelFeedAnimation, inOutAnimation } from 'src/app/shared/providers/animations-list';
import { environment } from 'src/environments/environment';
import { WebModelsCardComponent } from '../web-models-card/web-models-card.component';
import { WebnavComponent } from '../webnav/webnav.component';
import { CARD_CONTROL_BTN, CARDS_MODE, Cards_Page_State, ICard, ICardAction, ICardFeedModificator, INavpanelAction, ModelCardRendered, NAVPANEL_ACTION_TYPE, NoDataMessage } from 'src/app/models/card';
import { FOOTER_MODE, NAVBAR_BTN } from 'src/app/models/menu';
import { Subscription } from 'rxjs';
import { ICardCollection } from 'src/app/models/collection';
import { CardsService } from 'src/app/shared/providers/cards.service';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { ReviewCollectionsService } from 'src/app/shared/providers/review-collections.service';

import { SettingsService } from 'src/app/shared/providers/settings.service';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
import { WebNavService } from '../webnavigation.service';
import { LOCALSTORAGE_VAR } from 'src/app/models/localstorage';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent, DialogData } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';

@Component({
  selector: 'app-web-review',
  templateUrl: './web-review.component.html',
  styleUrls: ['./web-review.component.scss'],
  animations: [
    fullscreenCardAnimation,
    cardFeedAnimation,
    modelFeedAnimation,
    homeOverscrollAnimation,
    navbarmodelFeedAnimation,
    inOutAnimation
  ],
})
export class WebReviewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('collectionCardsFeed', { static: false })
  public collectionCardsFeed: WebModelsCardComponent;

  @ViewChild('modelCardsFeed', { static: false })
  public modelCardsFeedRef: WebModelsCardComponent;

  @ViewChild('navbarComponent', { static: false })
  public webnav: WebnavComponent;

  public currentAnimationState: string = Cards_Page_State.CARD_FEED;
  public CARDS_MODE = CARDS_MODE;
  public FOOTER_MODE = FOOTER_MODE;

  public isNoDataRecieved: boolean = false;
  public errorData: any;


  public sharedCollectionReference: ICardCollection;

  public cards: ICard[] = [];
  public collectionDetailsSource: ICardCollection;

  public backupPosterGeneratedFromFirstModel: string;
  public sharedFeedModificator: ICardFeedModificator

  public lessBtnSubscription: Subscription;
  public moreBtnSubscription: Subscription;

  public isModelFeedVisible: boolean = false;
  public modelFeedCards: ModelCardRendered[];
  public modelFeedCardStartPosition: number;

  public isCollectionDetailsShown: boolean = false;
  public isCollectionDetailsHiding: boolean = false;
  public currentCard: ICard;
  private pendingMoreCard: ModelCardRendered | null = null;

  public environment: any = environment
  public isSingleModelShared: boolean;
  modelIdChangeSubscription: Subscription;

  public sharedItemId: string;
  private isComponentActive: boolean = true;
  private activeLoadToken: number = 0;

  constructor(
    private router: Router,
    private readonly route: ActivatedRoute,
    public webNavService: WebNavService,
    public firebaseAuth: FirebaseAuthService,
    public cardService: CardsService,
    public reviewCollectionsService: ReviewCollectionsService,
    public utilityService: UtilityFunctionsService,
    public settingService: SettingsService,
    public userDataService: UserDataService,
    private dialog: MatDialog
  ) {}

  async ngOnInit(): Promise<void> {
    this.webNavService.footerMode = FOOTER_MODE.ADMIN_REVIEW;
    // http://localhost:4300/library?collectionId=6e93dc39-e00a-4dee-99c2-1c475be82683

    try {
      const loadToken = ++this.activeLoadToken;
      const reviewStatus = this.route.snapshot.data?.reviewStatus as string | undefined;

      if (reviewStatus) {
        this.sharedItemId = `reviews-${reviewStatus}`;
        const reviewsCollection = await this.reviewCollectionsService.getReviewsCollectionByStatus(reviewStatus);
        if (!this.isLoadTokenActive(loadToken)) return;
        this.applySharedData(reviewsCollection, 'collection');
      } else {
        const resolved = this.resolveSharedTarget();
        this.sharedItemId = resolved.sharedItemId;

        // https://web-dev.corp.3dway.io/model/ba15c9eb-abfa-448b-9daa-4ac41e387fb9
        // http://localhost:4300/collection/b93e7c50-42b9-49a8-a7b4-7cbf1f2617db

        const sharedData = await this.cardService.getSharedDataById(this.sharedItemId, resolved.sharedType);
        if (!this.isLoadTokenActive(loadToken)) return;
        this.applySharedData(sharedData, resolved.sharedType);
      }
    } catch (error) {
      console.error('Error fetching shared data:', error);
      this.utilityService.rollbarError(`User ${localStorage.getItem(LOCALSTORAGE_VAR.ORIGINAL_UID)}, Error fetching shared data: ${error}`);
      console.log(`User ${localStorage.getItem(LOCALSTORAGE_VAR.ORIGINAL_UID)}, Error fetching shared data: ${JSON.stringify(error)}`)

      // Determine the content type from URL path segments
      const pathSegments = this.route.snapshot.url.map(segment => segment.path);
      const contentType = pathSegments.includes('model') ? 'Model' : 'Collection';

      // Navigate to library page
      this.router.navigate(['/library']);

      // Show popup dialog with specific message based on content type
      this.dialog.open<ConfirmationDialogComponent, DialogData>(ConfirmationDialogComponent, {
        width: '370px',
        data: this.utilityService.applyPopupText(POPUP_TEXT.SHARED_CONTENT_NOT_AVAILABLE, '{contentType}', contentType),
      });
    }

    this.moreBtnSubscription = this.cardService.moreBtnSubject.subscribe((currentCard: ICard) => {
      this.handleMoreButtonClick(currentCard);
    });

    this.lessBtnSubscription = this.cardService.lessBtnSubject.subscribe(() => {
      this.handleLessButtonClick();
    });

  }

  ngAfterViewInit(): void {
    if (this.pendingMoreCard) {
      this.collectionCardsFeed?.removeLikeTouchedClass();
      this.pendingMoreCard = null;
    }
  }

  private resolveSharedTarget(): { sharedType: 'model' | 'collection'; sharedItemId: string } {
    const pathSegments = this.route.snapshot.url.map(segment => segment.path);
    const sharedTypeFromData = this.route.snapshot.data?.sharedType as 'model' | 'collection' | undefined;
    const sharedItemIdFromData = this.route.snapshot.data?.sharedItemId as string | undefined;
    const sharedType = sharedTypeFromData || (pathSegments.includes('model') ? 'model' : 'collection');
    let sharedItemId: string | undefined = sharedItemIdFromData;

    if (sharedType === 'model') {
      const modelIdParam = this.route.snapshot.paramMap.get('modelId');
      sharedItemId = modelIdParam || sharedItemIdFromData;
      if (!sharedItemId) {
        throw new Error('Missing modelId in route parameters');
      }
      return { sharedType, sharedItemId };
    }

    const collectionIdParam = this.route.snapshot.paramMap.get('collectionId');
    sharedItemId = collectionIdParam || sharedItemIdFromData;
    if (!sharedItemId) {
      throw new Error('Missing collectionId in route parameters');
    }
    return { sharedType, sharedItemId };
  }

  private applySharedData(sharedData: ICardCollection | ICard, sharedType: 'model' | 'collection'): void {
    if (!this.isComponentActive) return;
    if (sharedType === 'collection') {
      this.sharedCollectionReference = sharedData as ICardCollection;
      this.sharedFeedModificator = { isSharingModelFeed: true, isInReviewAdminMode: true };

      this.cards = this.cardService.convertCollectionsToCardsFeed([this.sharedCollectionReference]);
      this.collectionDetailsSource = sharedData as ICardCollection;
      console.log('this.collectionDetailsSource: ', this.collectionDetailsSource);
      this.cardService.setCurrentCard(this.cards[0]);
      this.handleMoreButtonClick(this.cards[0]);
      this.utilityService.rollbarInfo(`Shared collection opened, ${this.collectionDetailsSource.collectionAuthor}, userUid: ${this.firebaseAuth.currentUser?.uid}`)
      if (this.collectionDetailsSource.collectionAuthor === localStorage.getItem(LOCALSTORAGE_VAR.ORIGINAL_UID)) {
        console.log('User is author of shared collection, handling redirect to library: ', this.collectionDetailsSource.collectionId);
        this.invalidateActiveLoad();
        this.router.navigate(['/library/edit'], {
          queryParams: {
            collectionId: this.collectionDetailsSource.collectionId,
          }
        });
      }
      return;
    }

    this.isSingleModelShared = true;
    this.modelFeedCards = [sharedData] as ModelCardRendered[];
    this.isModelFeedVisible = true;
    // DIRTY HACK TO NOT WAIT FOR AUTH:
    if(this.modelFeedCards[0]?.cardAuthor === localStorage.getItem(LOCALSTORAGE_VAR.ORIGINAL_UID)) {
      this.router.navigate(['/portfolio'], {
        queryParams: {
          modelId: this.modelFeedCards[0].id,
          darkModeRedirect: true // Add darkMode parameter
        }
      });
    }
  }

  private handleMoreButtonClick(currentCard: ModelCardRendered): void {
    if (!this.isComponentActive) return;
    this.applyMoreState(currentCard);
    if (!this.collectionCardsFeed) {
      this.pendingMoreCard = currentCard;
      return;
    }
    this.collectionCardsFeed.removeLikeTouchedClass();
  }

  private applyMoreState(currentCard: ModelCardRendered): void {
    this.currentCard = currentCard;
    this.cardService.collectionDetailsInitTimeStart = performance.now();
    this.modelFeedCards = this.collectionDetailsSource.collectionCards;
    this.cardService.setLastCollectionCard(currentCard)
    this.isCollectionDetailsShown = true;
    this.webNavService.footerMode = FOOTER_MODE.ADMIN_REVIEW;
  }

  private handleLessButtonClick(): void {
    // We need to show collection wrapper only when it's 3DWay collection
    console.log('handleLessButtonClick:', this.currentCard);
    if (!this.currentCard?.cardPosterWeb) {
      console.log('handleLessButtonClick: no poster, redirecting to library');
      this.router.navigate(['/library']);
      return;
    }
    if (
      this.webNavService.footerMode === FOOTER_MODE.COLLECTION_DETAILS ||
      this.webNavService.footerMode === FOOTER_MODE.COLLECTION_DETAILS_FOR_SHARED
    ) {
      this.webnav?.removeLikeTouchedClass();
    }
    this.isCollectionDetailsShown = false;
    this.webNavService.footerMode = FOOTER_MODE.ADMIN_REVIEW;
    this.collectionCardsFeed?.setFirstCardExplicitVisible();
    this.collectionCardsFeed?.setActiveComponentCardToCardService();
    this.collectionCardsFeed?.startPlayVisibleCollectionCard();
  }


  public handleWebpanelClick(action: INavpanelAction) {
    const actionName = action.actionType
    switch (true) {
      case actionName === NAVPANEL_ACTION_TYPE.LIKE_COLLECTION:
        // DIRTY HACK: Because updates of navpanel items are very quickly and before navpanel hidden you see different variant;
         setTimeout(() => {
          this.toggleCollectionLike();
         }, 250);
        break;
    }
  }

  public onNavbarBtnClicked(navbarBtn: NAVBAR_BTN) {
    console.log('clicked ', navbarBtn)
    switch (navbarBtn) {
      case NAVBAR_BTN.HOME:
        this.router.navigate(['/']);
        break;
      case NAVBAR_BTN.LIBRARY:
        this.invalidateActiveLoad();
        this.router.navigate(['/library']);
        break;
      case NAVBAR_BTN.TO_TOP:
        this.scrollToTop();
        break;
      case NAVBAR_BTN.SEARCH:
        console.log('not implemented')
        break;
      case NAVBAR_BTN.BUY:
        console.log('BUY BTN CLICKED');
        break;
      case NAVBAR_BTN.BACK:
          // this.currentFooterMode = FOOTER_MODE.COLLECTION_DETAILS;
          this.utilityService.notImplemented();
        break;
      case NAVBAR_BTN.SELECT_ALL:
        this.utilityService.notImplemented();
        break;
      case NAVBAR_BTN.MORE_OPTIONS:
        this.utilityService.notImplemented();
        break;
      case NAVBAR_BTN.NOT_IMPL:
        this.utilityService.notImplemented();
        break;
      default:
        break;
    }
  }

  public onCardVisibilityChanged(card: ModelCardRendered) {
    this.webNavService.footerMode = this.isModelFeedVisible ? FOOTER_MODE.DEFAULT : FOOTER_MODE.ADMIN_REVIEW;
  }

  public onCollectionDetailsThumbClick(thumbNumber: number): void {
    this.modelFeedCards = this.collectionDetailsSource.collectionCards;
    console.log('onCollectionDetailsThumbClick, this.modelFeedCards: ', this.modelFeedCards)

    this.collectionCardsFeed.disposeAllVideosExceptCurrent();
    this.cardService.modelFeedInitStart = performance.now();

    this.modelFeedCardStartPosition = thumbNumber;
    this.webNavService.footerMode = FOOTER_MODE.DEFAULT;
    this.isModelFeedVisible = true;
  }

  public onReviewThumbClicked(card: ModelCardRendered): void {
    if (!card || !this.collectionDetailsSource?.collectionCards?.length) return;
    const thumbIndex = this.collectionDetailsSource.collectionCards.findIndex(item => item.id === card.id);
    if (thumbIndex < 0) return;
    this.onCollectionDetailsThumbClick(thumbIndex);
  }

  public onNavpanelActionItemClicked(item: INavpanelAction): void {
    console.log(item.actionName);
    this.handleNavpanelAction(item);
  }

  public handleNavpanelAction(action: INavpanelAction): void {
    const actionName = action.actionType
    switch (true) {
      case actionName === NAVPANEL_ACTION_TYPE.LIKE_COLLECTION:
          this.toggleCollectionLike();
        break;
      case actionName === NAVPANEL_ACTION_TYPE.SHARE_COLLECTION:
        this.utilityService.notImplemented();
        break;
      case actionName === NAVPANEL_ACTION_TYPE.SHARE_MODEL:
        this.modelCardsFeedRef.onShareBtnClicked(this.cardService.getCurrentCard());
        break;
      case actionName === NAVPANEL_ACTION_TYPE.UNLIKE_CARD:
        this.modelCardsFeedRef.dispatchCurrentCardLikeClick();
        break;
      default:
        break;
    }
  }

  private toggleCollectionLike(): void {
    if (!this.webnav) return;
    this.webnav.onCollectionLikeClicked(new Event('click'));
  }

  private scrollToTop(): void {
    const overlay = document.querySelector('.review-gallery-overlay') as HTMLElement | null;
    if (overlay) {
      overlay.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return;
    }
    const container = document.querySelector('.shared-content-page') as HTMLElement | null;
    if (container) {
      container.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  public onCardCollectionControlBtnClicked(action: ICardAction): void {
    console.log('onCardCollectionControlBtnClicked: ', action)
    this.utilityService.triggerHaptics();
    switch (action.controlAction) {
      case CARD_CONTROL_BTN.ANONYMOUS_USER:
        this.webnav.handleUnauthorizedUserActionDetected();
        break;
      case CARD_CONTROL_BTN.CONTROL_ACTIONS_DEFAULT:
      case CARD_CONTROL_BTN.CONTROL_ACTION_FOR_LIKED:
        this.utilityService.notImplemented();
        break;
      case CARD_CONTROL_BTN.UNLIKE_DRAFT_CARD:
        this.modelCardsFeedRef.dispatchCurrentCardLikeClick();
        break;
      case CARD_CONTROL_BTN.CONTROL_GO_TO_DETAILS:
        if (!this.isModelFeedVisible) {
          this.currentCard = action.card;
          this.cardService.triggerMoreBtnSubject();
        }
        break;
      case CARD_CONTROL_BTN.CONTROL_BACK_BTN:
          if(this.isSingleModelShared ) {
            this.router.navigate(['/library']);
            return;
          }
          this.webNavService.footerMode = FOOTER_MODE.ADMIN_REVIEW;
          this.cardService.setCurrentCard(this.currentCard);

          this.isModelFeedVisible = false;
          // this.navbarAnimationState = 'default';
        break
      case CARD_CONTROL_BTN.SEARCH:
        this.utilityService.showImportantSnackBar('Coming soon', 250, 750);
        break;
      case CARD_CONTROL_BTN.BUY_MODEL:
        this.utilityService.showImportantSnackBar('Coming soon', 250, 750);
        break;
      case CARD_CONTROL_BTN.REVIEW_APPROVE:
        this.openReviewApproveDialog(action.card);
        break;
      default:
        break;
    }
  }

  private openReviewApproveDialog(card: ICard): void {
    if (!card) return;
    const dialogConfig = {
      data: {
        dialogTitle: 'Review Model',
        dialogText: `Approve "${card.cardTitle}"?`,
        confirmBtntext: 'Approve',
        declineBtnText: 'Back',
        secondButtonText: 'Reject',
        customCssClass: 'title-paddings',
        singleButton: false,
      }
    };
    const dialogRef = this.dialog.open<ConfirmationDialogComponent, DialogData>(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === 'reject') {
        console.log('REJECTED');
        try {
          await this.cardService.rejectReviewModelPutRequest(card);
          await this.userDataService.refreshUploadedModelsForOwnedModeratedCard(card);
          this.utilityService.showImportantSnackBar('Model rejected', 100);
          this.handleReviewDecisionSuccess(card);
        } catch (error) {
          this.utilityService.showErrorSnackBar(`Reject failed: ${JSON.stringify(error)}`, 500);
        }
        return;
      }
      if (result !== true) return;
      try {
        const uid = await this.firebaseAuth.getUserUid();
        await this.cardService.publishModelsPostRequest([card.id], uid);
        await this.userDataService.refreshUploadedModelsForOwnedModeratedCard(card);
        this.utilityService.showImportantSnackBar('Model approved', 100);
        this.handleReviewDecisionSuccess(card);
      } catch (error) {
        this.utilityService.showErrorSnackBar(`Publish failed: ${JSON.stringify(error)}`, 500);
      }
    });
  }

  private handleReviewDecisionSuccess(card: ICard): void {
    this.removeCardFromReviewCollection(card.id);

    // After moderation decision, return from active model feed to the review feed.
    this.webNavService.footerMode = FOOTER_MODE.ADMIN_REVIEW;
    if (this.currentCard) {
      this.cardService.setCurrentCard(this.currentCard);
    }
    this.isModelFeedVisible = false;
  }

  private removeCardFromReviewCollection(cardId: string): void {
    if (!cardId || !this.collectionDetailsSource?.collectionCards) return;

    const nextCards = this.collectionDetailsSource.collectionCards.filter(sourceCard => sourceCard.id !== cardId);
    this.collectionDetailsSource.collectionCards = nextCards;

    if (this.sharedCollectionReference) {
      this.sharedCollectionReference.collectionCards = nextCards;
    }

    if (this.modelFeedCards) {
      this.modelFeedCards = nextCards as ModelCardRendered[];
    }

    this.collectionDetailsSource.purchaseDetails = {
      ...(this.collectionDetailsSource.purchaseDetails || { allCardsQuantity: 0 }),
      allCardsQuantity: nextCards.length,
    };
    this.collectionDetailsSource.updated = new Date().toISOString();

    const firstCard = nextCards[0];
    this.collectionDetailsSource.collectionContentMobile = firstCard?.cardContentMobile || '';
    this.collectionDetailsSource.collectionPosterMobile = firstCard?.cardPosterMobile || '';
    this.collectionDetailsSource.collectionPosterWeb = firstCard?.cardPosterWeb || '';
    this.collectionDetailsSource.collectionContentWeb = firstCard?.cardContentWeb || '';

    if (this.cards?.length > 0) {
      this.cards[0].cardContentMobile = this.collectionDetailsSource.collectionContentMobile;
      this.cards[0].cardPosterMobile = this.collectionDetailsSource.collectionPosterMobile;
      this.cards[0].cardPosterWeb = this.collectionDetailsSource.collectionPosterWeb;
      this.cards[0].cardContentWeb = this.collectionDetailsSource.collectionContentWeb;
      this.cards[0].modifiedDate = this.collectionDetailsSource.updated;
    }

    if (this.sharedCollectionReference) {
      this.sharedCollectionReference.purchaseDetails = this.collectionDetailsSource.purchaseDetails;
      this.sharedCollectionReference.updated = this.collectionDetailsSource.updated;
      this.sharedCollectionReference.collectionContentMobile = this.collectionDetailsSource.collectionContentMobile;
      this.sharedCollectionReference.collectionPosterMobile = this.collectionDetailsSource.collectionPosterMobile;
      this.sharedCollectionReference.collectionPosterWeb = this.collectionDetailsSource.collectionPosterWeb;
      this.sharedCollectionReference.collectionContentWeb = this.collectionDetailsSource.collectionContentWeb;
    }

  }


  ngOnDestroy(): void {
    this.invalidateActiveLoad();
    this.lessBtnSubscription?.unsubscribe();
    this.moreBtnSubscription?.unsubscribe();
  }

  private invalidateActiveLoad(): void {
    this.isComponentActive = false;
    this.activeLoadToken += 1;
  }

  private isLoadTokenActive(loadToken: number): boolean {
    return this.isComponentActive && loadToken === this.activeLoadToken;
  }


}
